import { render, staticRenderFns } from "./LesBoutons.vue?vue&type=template&id=6afdef03&scoped=true&"
import script from "./LesBoutons.vue?vue&type=script&lang=js&"
export * from "./LesBoutons.vue?vue&type=script&lang=js&"
import style0 from "./LesBoutons.vue?vue&type=style&index=0&id=6afdef03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afdef03",
  null
  
)

export default component.exports